import { Typography } from '@mui/material'

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  year: 'numeric',
  month: 'numeric',
  day: '2-digit',
})

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
})

const StackedDateTimeField = ({ record, source }) => {
  const value = record?.[source]
  if (!value) return <Typography variant='body2'>—</Typography>

  const date = new Date(value)

  return (
    <>
      <Typography variant='body2'>{dateFormatter.format(date)}</Typography>
      <Typography variant='body2'>{timeFormatter.format(date)}</Typography>
    </>
  )
}

export default StackedDateTimeField
